import React from 'react'
import MaterialSymbol from '../material-symbol'

const OpenInNew = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="open_in_new" {...props} />
))

OpenInNew.displayName = 'OpenInNew'

export default OpenInNew
